<!--
 * @Author: LiZhiWei
 * @Date: 2026-01-27 11:35:56
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-01-29 09:39:33
 * @Description: 
-->
<template>
  <div class="industry-timeline py-120px bg-white overflow-hidden select-none lt-sm:py-160px">
    <div
      class="landing-container content-wrapper flex items-center gap-60px h-600px lt-sm:flex-col lt-sm:h-auto lt-sm:px-32px lt-sm:gap-60px"
    >
      <!-- Left Content: Statistics & Description -->
      <div
        class="text-section w-550px h-full flex flex-col justify-center gap-16px lt-sm:w-full lt-sm:items-center lt-sm:h-auto"
      >
        <h2
          class="section-title pf-sc-semibold font-s-36px lh-60px lt-sm:font-s-48px lt-sm:lh-60px"
        >
          行业认可 荣誉见证
        </h2>
        <p class="section-desc pf-sc-regular font-s-16px text-main/70 lt-sm:font-s-26px">
          深耕行业发展，我们始终以技术创新为核心、以专业实力为根基，凭借扎实的研发积淀与优质的服务能力斩获多项权威认可。目前已成功取得5项项目专利，实现核心技术的硬核突破；拿下35项软件著作权，筑牢数字化研发的坚实壁垒；斩获13项行业荣誉，收获行业与市场的双重肯定。每一项成果，都是技术实力的直接彰显，更是专业口碑的有力见证。未来，我们将继续以荣誉为鞭策，深耕技术、持续创新，用更优质的成果回馈行业信赖。
        </p>
        <ul
          class="hero-metrics flex items-center gap-48px lt-sm:justify-center lt-sm:mt-20px lt-sm:gap-76px"
        >
          <li
            v-for="(item, index) in metrics"
            :key="index"
            class="metric flex items-start flex-col lt-sm:items-center"
          >
            <strong
              class="metric-value d-din-pro-600-semibold font-s-56px font-semibold text-primary lt-sm:font-s-68px"
            >
              {{ item.value }}
            </strong>
            <span class="metric-label font-s-14px text-#384146 lt-sm:font-s-24px">
              {{ item.label }}
            </span>
          </li>
        </ul>
      </div>

      <div
        class="marquee-section w-full relative flex justify-end overflow-hidden flex-1 h-600px flex-row gap-20px lt-sm:flex-col lt-sm:gap-0 lt-sm:w-100vw"
      >
        <!-- First Column/Row -->
        <InspiraMarquee
          :vertical="isVertical"
          class="marquee-col h-full lt-sm:h-auto lt-sm:w-full lt-sm:my--30px [--duration:50s]!"
          :pause-on-hover="true"
        >
          <div
            v-for="(item, index) in firstColumn"
            :key="`col1-${index}`"
            class="timeline-card bg-white rounded-xl overflow-hidden border border-slate-100 shadow-sm transition-all duration-300 group relative w-260px lt-sm:w-200px"
          >
            <div
              class="card-image-wrapper relative aspect-[4/3] bg-white flex items-center justify-center"
            >
              <img
                :src="item.image"
                :alt="item.title"
                class="card-image w-full h-full object-contain mix-blend-multiply"
                loading="lazy"
              />
            </div>
          </div>
        </InspiraMarquee>

        <!-- Second Column/Row (Reverse) -->
        <InspiraMarquee
          :vertical="isVertical"
          reverse
          :pause-on-hover="true"
          class="marquee-col h-full lt-sm:h-auto lt-sm:w-full lt-sm:my--30px [--duration:20s]!"
        >
          <div
            v-for="(item, index) in secondColumn"
            :key="`col2-${index}`"
            class="timeline-card bg-white rounded-xl overflow-hidden border border-slate-100 shadow-sm transition-all duration-300 group relative w-260px lt-sm:w-200px"
          >
            <div
              class="card-image-wrapper relative aspect-[4/3] bg-slate-50 flex items-center justify-center"
            >
              <img
                :src="item.image"
                :alt="item.title"
                class="card-image w-full h-full object-contain mix-blend-multiply"
                loading="lazy"
              />
            </div>
          </div>
        </InspiraMarquee>

        <!-- Third Column/Row -->
        <InspiraMarquee
          v-if="isVertical"
          :vertical="isVertical"
          :pause-on-hover="true"
          class="marquee-col h-full lt-sm:h-auto lt-sm:w-full lt-sm:my--30px [--duration:30s]!"
        >
          <div
            v-for="(item, index) in thirdColumn"
            :key="`col3-${index}`"
            class="timeline-card bg-white rounded-xl overflow-hidden border border-slate-100 shadow-sm transition-all duration-300 group relative w-260px lt-sm:w-200px"
          >
            <div
              class="card-image-wrapper relative aspect-[4/3] bg-slate-50 flex items-center justify-center"
            >
              <img
                :src="item.image"
                :alt="item.title"
                class="card-image w-full h-full object-contain mix-blend-multiply"
                loading="lazy"
              />
            </div>
          </div>
        </InspiraMarquee>

        <!-- Gradient Overlay -->
        <div
          class="gradient-overlay-top pointer-events-none absolute z-10 from-white to-transparent inset-x-0 top-0 h-1/8 bg-gradient-to-b lt-sm:inset-y-0 lt-sm:left-0 lt-sm:w-1/4 lt-sm:bg-gradient-to-r lt-sm:h-full lt-sm:right-auto"
        ></div>
        <div
          class="gradient-overlay-bottom pointer-events-none absolute z-10 from-white to-transparent inset-x-0 bottom-0 h-1/8 bg-gradient-to-t lt-sm:inset-y-0 lt-sm:right-0 lt-sm:w-1/4 lt-sm:bg-gradient-to-l lt-sm:h-full lt-sm:left-auto"
        ></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { industryCertificates } from '@/constants/patents'

  const metrics = [
    { value: '5', label: '项目专利' },
    { value: '13', label: '行业荣誉' },
    { value: '35', label: '软件著作权' },
  ]
  const isVertical = ref(true)

  // Flatten the industryCertificates grouped by year into a single array
  const allCertificates = computed(() => {
    return industryCertificates.flatMap((group) =>
      group.items.map((item) => ({
        ...item,
        year: group.year,
      }))
    )
  })

  // Split certificates into columns based on layout
  const firstColumn = computed(() => {
    const divisor = isVertical.value ? 3 : 2
    return allCertificates.value.filter((_, index) => index % divisor === 0)
  })

  const secondColumn = computed(() => {
    const divisor = isVertical.value ? 3 : 2
    return allCertificates.value.filter((_, index) => index % divisor === 1)
  })

  const thirdColumn = computed(() => {
    if (!isVertical.value) return []
    return allCertificates.value.filter((_, index) => index % 3 === 2)
  })

  onMounted(() => {
    const checkLayout = () => {
      isVertical.value = window.innerWidth >= 768 // lg breakpoint
    }
    checkLayout()
    window.addEventListener('resize', checkLayout)
    onUnmounted(() => {
      window.removeEventListener('resize', checkLayout)
    })
  })
</script>

<style scoped>
  .hide-scrollbar {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
  .hide-scrollbar::-webkit-scrollbar {
    display: none;
  }
</style>
